import React, { Fragment } from 'react';
import markerPath from 'map_marker.svg';
import ActiveMarker from '../Map/ActiveMarker';

const EventMarker = ({ event, changeActiveMarker, activeMarker }) => {
  return (
    <Fragment>
      {activeMarker === event.id ? (
        <ActiveMarker
          changeActiveMarker={changeActiveMarker}
          listing={event}
          type="event"
        />
      ) : (
        <button
          aria-label="View Event"
          name="View Event"
          className="listing-marker"
          onClick={() => changeActiveMarker(event.id)}
          // onBlur={() => changeActiveMarker(null)}
          type="button"
        >
          <img
            id={event.id}
            data-src={markerPath}
            alt="Event marker"
            title="Event Marker"
            className="hover-effect lazyload"
          />
        </button>
      )}
    </Fragment>
  );
};

export default EventMarker;
